"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sections = require("../components/contentful-views/sections");

var _carouselSection = _interopRequireDefault(require("../components/carouselSection/carouselSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CarouselWidget = function CarouselWidget(_ref) {
  var title = _ref.title,
      delay = _ref.delay,
      showPagination = _ref.showPagination,
      content = _ref.content;
  var slides = (0, _sections.getSectionsArray)(content, {});
  return /*#__PURE__*/_react["default"].createElement(_carouselSection["default"], {
    delay: delay,
    title: title,
    showPagination: showPagination
  }, slides);
};

CarouselWidget.propTypes = {
  title: _propTypes["default"].string,
  delay: _propTypes["default"].number,
  showPagination: _propTypes["default"].bool,
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
(0, _sections.registerWidget)('carousel', CarouselWidget);
var _default = CarouselWidget;
exports["default"] = _default;